import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CustomerFocusKeyItem } from "src/app/shared/models/CustomerFocusKey.item";
import { CustomerTokenItem } from "src/app/shared/models/CustomerToken.item";

@Component({
	selector: "app-customer-focus-key-setup",
	templateUrl: "./customer-focus-key-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerFocusKeySetupComponent implements OnInit {
	@Input() customerKey: string;
	@Input() venueKey: number;

	customerFocusKeyList: CustomerFocusKeyItem[];
	customerFocusKeySelected: CustomerFocusKeyItem;

	customerTokenList: CustomerTokenItem[];

	moment: any = moment;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		this.focusKeysGet(this.customerKey);
	}

	async focusKeysGet(customerKey) {
		const resp = await this.focuslink.customerFocusKeyGetAll(this.venueKey, customerKey);
		this.customerFocusKeyList = resp.map((i) => new CustomerFocusKeyItem(i));
	}

	focusKeyDelete(rec: CustomerFocusKeyItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete ${rec.sk} from this customer's profile?`,
			accept: async () => {
				this.focuslink.customerFocusKeyDelete(this.venueKey, rec.pk.replace(`CUSFOCKEY_`, ""), rec.sk);
				const idx = this.customerFocusKeyList.findIndex((i) => i.sk === rec.sk);
				this.customerFocusKeyList.splice(idx, 1);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async focusKeyNew() {
		this.tokensGet(this.customerKey);
		this.customerFocusKeySelected = new CustomerFocusKeyItem({
			pk: `CUSFOCKEY_${this.customerKey}`,
			created: moment().format(),
			venueKey: this.venueKey,
		});
	}

	focusKeyNewSave() {
		this.focuslink.customerFocusKeyPost(this.venueKey, this.customerKey, this.customerFocusKeySelected.sk, this.customerFocusKeySelected.token);
		this.customerFocusKeySelected.customerTokenItem = this.customerTokenList.find((i) => i.token === this.customerFocusKeySelected.token);
		this.customerFocusKeyList.push(this.customerFocusKeySelected);
	}

	async tokensGet(customerKey) {
		const resp = await this.focuslink.customerTokenGetAll(this.venueKey, this.customerKey);
		this.customerTokenList = resp.map((i) => new CustomerTokenItem(i));
	}
}
